import { Trans, useLingui } from "@lingui/react/macro";
import { Globe } from "lucide-react";
import { activateLocale } from "~/i18n/i18n";
import {
  LANGUAGE_LABELS,
  SUPPORTED_LANGUAGES,
  setLocaleCookie,
} from "~/utils/i18n";

interface LanguageBannerProps {
  value: string;
  onChange: (language: string) => void;
}

export function LanguageBanner({ value, onChange }: LanguageBannerProps) {
  const { t, i18n } = useLingui();
  const showEnglishAnchor = i18n.locale !== "en";
  return (
    <div className="flex flex-col gap-2 w-full rounded-lg border border-border bg-muted/40 p-3">
      <div className="flex items-center gap-2">
        <Globe className="w-4 h-4 text-muted-foreground shrink-0" />
        <div className="flex flex-col">
          <span className="text-sm font-semibold leading-5 text-foreground">
            <Trans>Choose your language</Trans>
          </span>
          {showEnglishAnchor && (
            // eslint-disable-next-line lingui/no-unlocalized-strings -- English anchor so the option is legible regardless of detected language
            <span className="text-xs leading-4 text-muted-foreground">Choose your language</span>
          )}
        </div>
      </div>
      <select
        id="language"
        aria-label={t`Language`}
        value={value}
        onChange={(e) => {
          activateLocale(e.target.value);
          setLocaleCookie(e.target.value);
          onChange(e.target.value);
        }}
        className="h-10 rounded-lg border border-border bg-background px-3 text-sm text-foreground"
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <option key={lang} value={lang}>
            {LANGUAGE_LABELS[lang]}
          </option>
        ))}
      </select>
      <span className="text-xs leading-4 text-muted-foreground">
        <Trans>Auto-detected from your browser. You can change it anytime.</Trans>
      </span>
    </div>
  );
}

export default LanguageBanner;
